import api from "@/lib/api";
import type {
    ComplianceItemType,
    CreateItemTypeInput,
    EmployeeComplianceProfile,
    UpsertComplianceItemInput,
    EmployeeComplianceItem,
    VerifyItemInput,
    OrgComplianceSummary,
    ComplianceGapReport,
    Framework,
    CreateFrameworkInput,
    FrameworkDetail,
} from "./types";

const BASE = "/compliance";

// Item Types
export const listItemTypes = (activeOnly = true) =>
    api.get<ComplianceItemType[]>(`${BASE}/types`, { params: { active: activeOnly } });

export const createItemType = (data: CreateItemTypeInput) =>
    api.post<ComplianceItemType>(`${BASE}/types`, data);

export const updateItemType = (id: string, data: Partial<CreateItemTypeInput>) =>
    api.put<ComplianceItemType>(`${BASE}/types/${id}`, data);

// Employee Profile
export const getEmployeeProfile = (userId: string) =>
    api.get<EmployeeComplianceProfile>(`${BASE}/users/${userId}`);

export const submitComplianceItem = (userId: string, data: UpsertComplianceItemInput) =>
    api.post<EmployeeComplianceItem>(`${BASE}/users/${userId}/items`, data);

// Verification
export const verifyItem = (id: string, data: VerifyItemInput) =>
    api.put<EmployeeComplianceItem>(`${BASE}/items/${id}/verify`, data);

// Reports
export const getOrgSummary = () =>
    api.get<OrgComplianceSummary>(`${BASE}/summary`);

export const getGapReport = () =>
    api.get<ComplianceGapReport[]>(`${BASE}/gaps`);

// V2 Architecture
export const listFrameworks = () =>
    api.get<Framework[]>(`${BASE}/frameworks`);

export const createFramework = (data: CreateFrameworkInput) =>
    api.post<Framework>(`${BASE}/frameworks`, data);

export const getFramework = (id: string) =>
    api.get<FrameworkDetail>(`${BASE}/frameworks/${id}`);

export const deleteFramework = (id: string) =>
    api.delete(`${BASE}/frameworks/${id}`);

export const listControls = () =>
    api.get<any[]>(`${BASE}/controls`);

export const createControl = (data: any) =>
    api.post(`${BASE}/controls`, data);

export const listRisks = () =>
    api.get<any[]>(`${BASE}/risks`);

export const createRisk = (data: any) =>
    api.post(`${BASE}/risks`, data);

export const listAudits = () =>
    api.get<any[]>(`${BASE}/audits`);

export const createAudit = (data: any) =>
    api.post(`${BASE}/audits`, data);